/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function FeaturesRepresentationFromJSON(json) {
    return FeaturesRepresentationFromJSONTyped(json, false);
}
export function FeaturesRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        canSeeUsersGroupsManagement: json['canSeeUsersGroupsManagement'],
        canSeeTagsInModel: json['canSeeTagsInModel'],
        canSeeClusterFlowAdd: json['canSeeClusterFlowAdd'],
        canSeeAdministrationMenu: json['canSeeAdministrationMenu'],
        canSeeYearVersionLocks: json['canSeeYearVersionLocks'],
        canSeeImport: json['canSeeImport'],
        canSeeRemoteJobs: json['canSeeRemoteJobs'],
        canSeeEntryLinks: json['canSeeEntryLinks'],
        canSeeComments: json['canSeeComments'],
        canSeeTagsInNavbar: json['canSeeTagsInNavbar'],
        canSeeTagsSidebar: json['canSeeTagsSidebar'],
        canSeeCredentials: json['canSeeCredentials'],
        canSeeListItemDescription: json['canSeeListItemDescription'],
        canSeeListItemTags: json['canSeeListItemTags'],
        canSeeInputSetup: json['canSeeInputSetup'],
        canSeeAuditLogs: json['canSeeAuditLogs'],
    };
}
export function FeaturesRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        canSeeUsersGroupsManagement: value.canSeeUsersGroupsManagement,
        canSeeTagsInModel: value.canSeeTagsInModel,
        canSeeClusterFlowAdd: value.canSeeClusterFlowAdd,
        canSeeAdministrationMenu: value.canSeeAdministrationMenu,
        canSeeYearVersionLocks: value.canSeeYearVersionLocks,
        canSeeImport: value.canSeeImport,
        canSeeRemoteJobs: value.canSeeRemoteJobs,
        canSeeEntryLinks: value.canSeeEntryLinks,
        canSeeComments: value.canSeeComments,
        canSeeTagsInNavbar: value.canSeeTagsInNavbar,
        canSeeTagsSidebar: value.canSeeTagsSidebar,
        canSeeCredentials: value.canSeeCredentials,
        canSeeListItemDescription: value.canSeeListItemDescription,
        canSeeListItemTags: value.canSeeListItemTags,
        canSeeInputSetup: value.canSeeInputSetup,
        canSeeAuditLogs: value.canSeeAuditLogs,
    };
}
